import angular from 'angular';
import { dateHumanFilter } from './dateHumanFilter';

angular.module('sh.dateHuman', []).filter('shDateHuman', dateHumanFilter);
